import { useState, useEffect } from "react";
import { Container, Row, Col } from "../../atoms/DependencyHelper";
import styles from "./HeroCarousel.module.scss";
import OwlCarousel from "react-owl-carousel2";
import PropTypes from "prop-types";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import { componentResize, createMarkup } from "../../../utils/helperServices";
import CTAButton from "../../atoms/CTAButton/CTAButton";
import labels from "../../../config/labels";

const HeroCarousel = ({
  slides = [],
  btnVariant,
  slideIndex,
  carouselBtnVariant,
  id,
  setCarouselPriority,
  page
}) => {
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const isMobile = componentResize();
  let heroCarousel;

  const next = () => {
    if (heroCarousel) {
      heroCarousel.next(600);
    }
  };
  const prev = () => {
    if (heroCarousel) {
      heroCarousel.prev(600);
    }
  };

  const isMultiple = () => slides.length > 1;

  const carouselOptions = {
    nav: false,
    autoplay: false,
    animateIn: "animate__fadeIn",
    margin: 0,
    autoWidth: true,
    lazyLoad: true,
    dotsClass: `${styles["owl-dots"]}`,
    dotClass: `${styles["owl-dot"]}`,
    slideBy: 1,
    dots: isMultiple(),
    loop: false,
    responsive: {
      0: {
        slideBy: 1,
      },
    },
  };
  useEffect(() => {
    if(page && page == labels.lbl_buy_bundle && slideIndex){
      heroCarousel.goTo(slideIndex);
    }
  }, [slideIndex]);

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
      if(page && page == labels.lbl_buy_bundle){
        setCarouselPriority(event.item.index)
      }
    },
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
      index +
        carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
      maximum
        ? "disabled"
        : "";

    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  return (
    <div className={styles["hero-carousel"]}>
      <OwlCarousel
        ref={(c) => (heroCarousel = c)}
        options={carouselOptions}
        events={events}
      >
        {slides.map((_slide, i) => (
          <div
            key={i}
            className={styles.slide}
            style={{
              backgroundImage:
                _slide.mobileImage && isMobile
                  ? `url(${_slide.mobileImage})`
                  : `url(${_slide.image})`,
            }}
          >
            <Container
              id={_slide.id}
              data-cms-title={_slide.title ? _slide.title : _slide.heading}
            >
              <Row>
                <Col xs={12} md={11} lg={6}>
                  <div
                    className={`${styles["content"]} ${styles[_slide.theme ?"content--"+_slide.theme.toLowerCase() :"content--light" ]}`}
                  >
                    {Boolean(_slide.title) && (
                      <div className={styles["content__title"]}>
                        {_slide.title}
                      </div>
                    )}
                    {Boolean(_slide.heading) && (
                      <div className={styles["content__heading"]}>
                        {_slide.heading}
                      </div>
                    )}
                    {Boolean(_slide.description) && (
                      <div
                        className={styles["content__description"]}
                        dangerouslySetInnerHTML={createMarkup(
                          _slide.description
                        )}
                      ></div>
                    )}
                    {Boolean(_slide.callToActionLabel) && (
                      <CTAButton
                        className={styles["content__cta"]}
                        id={`${_slide.id}_CTABtn_${i}`}
                        url={_slide.callToActionUri}
                        isOpenNewTab={_slide.isOpenNewTab}
                        handleClick={() => {}}
                        variant={btnVariant}
                      >
                        {_slide.callToActionLabel}
                      </CTAButton>
                    )}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        ))}
      </OwlCarousel>
      {isMultiple() && (
        <div className={`custom-owl--nav ${styles["nav"]}`}>
          <CarouselButton
            prev
            handleClick={prev}
            className={`${previousNavClass} ${styles["prev-arrow"]}`}
            btnTheme={carouselBtnVariant.toLowerCase()}
            id={`${id}` + "_arrowNxtBtn"}
          />
          <CarouselButton
            next
            handleClick={next}
            className={`${nextNavClass} ${styles["next-arrow"]}`}
            btnTheme={carouselBtnVariant.toLowerCase()}
            id={`${id}` + "_arrowBackBtn"}
          />
        </div>
      )}
    </div>
  );
};

HeroCarousel.defaultProps = {
  slides: [],
  btnVariant: "",
  slideIndex: 0,
  carouselBtnVariant: "Dark",
};
HeroCarousel.propTypes = {
  slides: PropTypes.array,
  btnVariant: PropTypes.string,
  slideIndex: PropTypes.number,
  carouselBtnVariant: PropTypes.string,
  id: PropTypes.string,
};

export default HeroCarousel;
